import { render } from "./signature-component.vue?vue&type=template&id=18c0e761&scoped=true"
import script from "./signature-component.vue?vue&type=script&lang=js"
export * from "./signature-component.vue?vue&type=script&lang=js"

import "./signature-component.vue?vue&type=style&index=0&id=18c0e761&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c0e761"]])

export default __exports__